<template>
	<div class="contact-selector">
		<span class="contact-selector-label">{{ label }}</span>
		<v-combobox
			ref="EmailInput"
			class="contact-selector-input"
			v-model="to"
			:items="contactMap"
			hide-details
			dense
			solo
			flat
			:multiple="true"
			small-chips
			deletable-chips
			:aria-label="label"
			:menu-props="{ contentClass: 'contact-selector-menu' }"
			@change="updateRecipients"
		>
		</v-combobox>
	</div>
</template>

<script>
	export default {
		name: 'ContactSelector',

		props: ['toList', 'label', 'contacts'],

		components: {},

		data: function() {
			return {
				to: [...this.toList],
			};
		},

		mounted() {},

		beforeDestroy() {},

		methods: {
			updateRecipients: function() {
				this.$emit('update', this.to.map((recipient) => recipient.replace(/.*<([^>]+)>$/, '$1').trim()));
			},

			isMatch: function(val1, val2) {
				if (val1 && val2) {
					return val1.trim().toLowerCase().includes(val2.trim().toLowerCase());
				} else {
					return false;
				}
			},

			validateEmail: function(email) {
				let re = /\S+@\S+\.\S+/;
				return re.test(email);
			},
		},

		computed: {
			contactMap: function() {
				let contacts = this.contacts.filter((c) => c.email);

				return contacts.map((c) => c.firstName + ' ' + c.lastName + ' <' + c.email + '>');
			},
		},
	};
</script>

<style scoped lang="scss">
	.contact-selector {
		min-height: 48px;
		display: flex;
		align-items: center;
		gap: 9px;
		padding: 2px 8px 2px 12px;
		border: 1px solid var(--portal-border);
		border-radius: var(--brand-field-radius, 12px);
		background: var(--v-gray_10-base);
		transition: border-color 140ms ease, background-color 140ms ease, box-shadow 140ms ease;
	}

	.contact-selector:focus-within {
		border-color: var(--v-primary-base);
		background: var(--portal-surface);
		box-shadow: 0 0 0 3px color-mix(in srgb, var(--v-primary-base) 10%, transparent);
	}

	.contact-selector-label {
		flex: 0 0 auto;
		color: var(--portal-muted);
		font-size: 12px;
		font-weight: 600;
	}

	.contact-selector-input {
		min-width: 0;
		flex: 1;
	}

	.contact-selector-input ::v-deep .v-input__control,
	.contact-selector-input ::v-deep .v-input__slot {
		min-height: 42px;
	}

	.contact-selector-input ::v-deep .v-input__slot {
		margin: 0;
		padding: 0 4px;
		background: transparent !important;
		box-shadow: none !important;
	}

	.contact-selector-input ::v-deep .v-select__slot {
		min-width: 0;
	}

	.contact-selector-input ::v-deep input {
		min-width: 80px;
		color: var(--portal-text);
		font-size: 13px;
	}

	.contact-selector-input ::v-deep .v-chip {
		height: 26px;
		border-radius: 999px;
		background: var(--v-gray_20-base);
		color: var(--portal-text);
		font-size: 11px;
	}

	@media (max-width: 599px) {
		.contact-selector {
			align-items: flex-start;
			flex-direction: column;
			gap: 0;
			padding-top: 9px;
		}

		.contact-selector-input {
			width: 100%;
		}
	}
</style>

<style lang="scss">
	.contact-selector-menu {
		margin-top: 6px;
		padding: 6px;
		border: 1px solid var(--portal-border);
		border-radius: var(--brand-surface-radius, 12px) !important;
		background: var(--portal-surface);
		box-shadow: 0 14px 38px rgba(17, 24, 39, 0.14) !important;
	}

	.contact-selector-menu .v-list {
		padding: 0;
		background: transparent;
	}

	.contact-selector-menu .v-list-item {
		min-height: 40px;
		border-radius: var(--brand-button-radius, 8px);
		font-size: 13px;
	}
</style>
